import {
  Delete,
  FileCodeCorner,
  FileXCorner,
  Globe,
  Trash,
  Trash2,
} from "lucide-react";
import React from "react";
import MyTabs from "../../../tools/MyTabs";
import PageTitle from "../../../global/PageTitle";
import LandingPage from "../website/LandingPage";
import PrivacyPolicy from "../website/PrivacyPolicy";
import MyCard from "../../../tools/MyCard";
import { SolidButton } from "../../../global/SolidButton";

export default function Pages() {
  return (
    <div className="space-y-2 px-2">
      <MyTabs
        position="left"
        tabs={[
          {
            label: "Landing Page",
            content: <Landing />,
            icon: Globe,
          },
          {
            label: "Privacy Policy",
            content: <PolicyPage />,
            icon: FileCodeCorner,
          },
          {
            label: "Data Deletion",
            content: <DataDeletion />,
            icon: FileXCorner,
          },
        ]}
      />
    </div>
  );
}

export const Landing = () => {
  return (
    <>
      <div className="flex flex-col w-full">
        <PageTitle
          title="Landing Page"
          subtitle="Upload and preview your app landing page HTML file"
        />
        <LandingPage />
      </div>
    </>
  );
};
export const PolicyPage = () => {
  return (
    <>
      <div className="">
        <PageTitle
          title="Privacy Policy"
          subtitle="Upload and preview Privacy Policy page HTML file"
        />
        <PrivacyPolicy />
      </div>
    </>
  );
};
export const DataDeletion = () => {
  return (
    <>
      <div className="w-160 ">
        <PageTitle
          title="Data Deletion Policy"
          subtitle="Manage your app's data deletion policy (Right to Erasure). This page is automatically generated for your app."
        />
        <MyCard className="p-4 mt-5 justify-center flex flex-col items-center">
          <Trash2 className="text-white bg-red-500 rounded-full p-4 w-14 h-14" />
          <h3 class="text-lg font-semibold mt-4 text-foreground/90">
            Generate Data Deletion Policy
          </h3>
          <p class="text-gray-600 text-center dark:text-gray-400 text-sm mt-2 max-w-md mx-auto">
            Create a comprehensive data deletion policy page that complies with
            privacy regulations and provides clear instructions for users to
            request data deletion.
          </p>
          <div class="bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-900/50 rounded-xl p-4 text-left w-full mt-3">
            <p class="text-xs text-blue-800 dark:text-blue-200 leading-relaxed">
              <span class="font-semibold block mb-2">📋 What's included:</span>
            </p>
            <ul class="text-xs text-blue-800 dark:text-blue-200 space-y-1 ml-4 list-disc">
              <li>Request submission process</li>
              <li>Verification requirements</li>
              <li>Timeline and expectations</li>
              <li>Email template for users</li>
              <li>Contact information</li>
            </ul>
          </div>
          <SolidButton className="mt-4 px-6">
            <span>
                Generate Data Deletion Policy
            </span>
          </SolidButton>
        </MyCard>
      </div>
    </>
  );
};
